window.STBInitMerch=function(){const container=document.getElementById('stbm-products');if(!container||container.dataset.stbReady)return;container.dataset.stbReady='true';


  const filters =
    document.querySelectorAll(".stbm-filter");

  const products =
    document.querySelectorAll(".stbm-product");


  filters.forEach(function(button){

    button.addEventListener("click", function(event){
      event.preventDefault();
      const category =
        this.dataset.filter;

      filters.forEach(function(btn){
        btn.classList.remove("active");
      });

      this.classList.add("active");

      products.forEach(function(product){

        product.style.display =
          category === "all" ||
          product.dataset.category === category
          ? "block"
          : "none";

      });

    });

  });


  document
    .querySelectorAll(".stbm-faq-question")
    .forEach(function(button){

      button.addEventListener("click", function(){

        const open=this.closest(".stbm-faq-item").classList.toggle("open");this.setAttribute("aria-expanded",String(open));

      });

    });


};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',window.STBInitMerch,{once:true});else window.STBInitMerch();document.addEventListener('shopify:section:load',window.STBInitMerch);
